var $fb9cd4429353d32d$exports = {};
$fb9cd4429353d32d$exports = {
    "colorSwatchPicker": `Spalv\u{173} pavyzd\u{17E}iai`,
    "dropzoneLabel": `\u{201E}DropZone\u{201C}`,
    "selectPlaceholder": `Pasirinkite element\u{105}`,
    "tableResizer": `Dyd\u{17E}io keitiklis`
};


export {$fb9cd4429353d32d$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
